export const signalRKeysEnum = {
  RefereshChargingTransacitonData: "RefereshChargingTransacitonData",
  StopChargingTransaction: "StopChargingTransaction",
  RefreshChargePointStatus: "RefreshChargePointStatus",
};
